import React, { useEffect } from "react";
import { SiteHeader, SiteFooter } from "./SiteChrome";
import { CONTACT, BROCHURES } from "./siteConfig";
import "./Site.css";

export default function SiteSupportPage() {
  useEffect(() => {
    document.title = "Support — DecisionFlow";
  }, []);

  useEffect(() => {
    document.documentElement.classList.add("site-html");
    document.body.classList.add("site-body");
    return () => {
      document.documentElement.classList.remove("site-html");
      document.body.classList.remove("site-body");
    };
  }, []);

  return (
    <div className="site">
      <SiteHeader />

      <main id="top">
        <section className="site-section">
          <div className="site-container site-legal">
            <p className="site-eyebrow">Support</p>
            <h1>Get help with DecisionFlow</h1>
            <p>
              For anything account or product related — setup, a question
              about a feature, or something that looks wrong — reach us
              directly:
            </p>

            <div className="site-support-contact">
              <a className="site-btn site-btn-primary" href={`mailto:${CONTACT.supportEmail}?subject=DecisionFlow support`}>
                Email {CONTACT.supportEmail}
              </a>
              <a className="site-btn site-btn-ghost" href={`tel:${CONTACT.phoneHref}`}>
                Call {CONTACT.phone}
              </a>
            </div>

            <h2>Before you write in</h2>
            <ul>
              <li>Say whether you're on Project &amp; Document Management or Manufacturing &amp; Production Tracking — the two versions work differently.</li>
              <li>Include your company name and, if it's a specific project or order, its name or number.</li>
              <li>A screenshot of what you're seeing gets you a faster answer than a description alone.</li>
            </ul>

            <h2>Setup and training</h2>
            <p>
              New accounts get setup and training in under 30 minutes as part
              of onboarding — if you haven't had that yet, or your team has
              grown since, email us to book a session.
            </p>

            <h2>Brochures</h2>
            <p>A one-page overview of each version, if you need something to forward internally:</p>
            <ul>
              {Object.entries(BROCHURES).map(([id, b]) => (
                <li key={id}>
                  <a href={b.href} download>{b.name} (PDF)</a>
                </li>
              ))}
            </ul>
          </div>
        </section>
      </main>

      <SiteFooter />
    </div>
  );
}
